import { Star } from '@mui/icons-material'
import { Grid, Tooltip } from '@mui/material'
import React from 'react'
import { getI18n, useTranslation } from 'react-i18next'
import { ILinkedSkill, IWorkHistoryDetails } from '../../../../interfaces/projects/IProjects'
import { OPAccordionItem } from '../../../Accordion/OPAccordionItem'
import { OPNewTable } from '../../../OPcomponents/OPNewTable'
import ProfileWorkHistoryForm from './ProfileWorkHistoryForm'

interface IProps {
  publicWorkHistory: IWorkHistoryDetails[]
  publicWorkHistoryLoading: boolean
  onRowClick: (id: number | string) => Promise<unknown>
}

const ProfilePublicWorkHistory = ({ publicWorkHistory, publicWorkHistoryLoading, onRowClick }: IProps): JSX.Element => {
  const { t } = useTranslation()

  const publicWorkHistoryList = publicWorkHistory.map((work) => {
    return {
      id: work.projectId,
      rows: {
        [t('Projects.ProjectName')]: { text: work.projectName, width: '25%' },
        [t('WorkHistory.Customer')]: { text: work.customer, width: '25%' },
        [t('WorkHistory.Expirience')]: { text: `${work.daysWorked || 0} ${t('Date.ExperienceDays')}`, width: '10%' },
        [t('Projects.KeyProject')]: {
          text: work.isKeyProject ? <Star color='primary' /> : '',
          width: '9%',
          align: 'center' as const,
        },
        [t('WorkHistory.Skills')]: {
          text: (
            <Tooltip
              title={work.linkedSkills
                .map((s: ILinkedSkill) => (getI18n().language === 'en' && s.skillNameEng?.length ? s.skillNameEng : s.skillNameFi))
                .join(', ')}
              placement='bottom'
              arrow
            >
              <span>{work.linkedSkills.length}</span>
            </Tooltip>
          ),
          width: '10%',
        },
      },
    }
  })

  return (
    <Grid item xs={12}>
      <OPAccordionItem
        title={`${t('WorkHistory.PersonNetumWorkHistory')} (${publicWorkHistoryLoading ? '\u2026' : publicWorkHistory.length})`}
        content={
          <Grid container spacing={5} className='gridcontainer--formcontainer__addnewpaddings'>
            <Grid item xs={12}>
              {publicWorkHistory.length > 0 ? (
                <OPNewTable
                  rows={publicWorkHistoryList}
                  curLength={publicWorkHistoryList.length}
                  onRowClick={onRowClick}
                  FormBase={ProfileWorkHistoryForm}
                />
              ) : (
                <p className='profile--deptext profpadding'>{t('Profile.NoAddedWorkHistoryPublic')}</p>
              )}
            </Grid>
          </Grid>
        }
      />
    </Grid>
  )
}

export default ProfilePublicWorkHistory
